import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addItem: {
    id: 'footer-links-settings-additem',
    defaultMessage: 'Add item',
  },
  moveItemUp: {
    id: 'footer-links-settings-move-item-up',
    defaultMessage: 'Move item up',
  },
  moveItemDown: {
    id: 'footer-links-settings-move-item-down',
    defaultMessage: 'Move item down',
  },
  title: {
    id: 'footer-links-settings-title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'footer-links-settings-description',
    defaultMessage: 'Description',
  },
  url: {
    id: 'footer-links-settings-url',
    defaultMessage: 'URL',
  },
  deleteItem: {
    id: 'footer-links-settings-delete-item',
    defaultMessage: 'Delete link',
  },
});
